export const MAFIA_NEXT_SHIPPING_OPTION_321483 = 'MAFIA_NEXT_SHIPPING_OPTION_321483';
export const MAFIA_SPLIT_SHIPMENTS_PLUGIN_377648 = 'MAFIA_SPLIT_SHIPMENTS_PLUGIN_377648';
export const MAFIA_CREDIT_CARD_VERIFY_410058 = 'MAFIA_CREDIT_CARD_VERIFY_410058';
export const MARTY_441335 = 'MARTY_441335';
